/* eslint-disable no-useless-catch */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-new */
/* eslint-disable no-console */
/* eslint-disable max-len */
import { FileRejection } from 'react-dropzone';
import { toast } from 'react-toastify';
import { getBlobUrl, newNewsFeedUploadFiles } from '../../../../../../../libs/HelperContent';
import Compressor from 'compressorjs';
import heic2any from 'heic2any';

export const onDropRejected = (fileRejections: FileRejection[], footerActn, language) =>
{
	// Set maxFiles based on footerActn: 5 for documents, 20 for images/videos
	const maxFiles = footerActn === 'application' ? 5 : 20;

	const errorMessages = new Set<string>();
	const showToastError = (message: string) =>
	{
		toast.error(message, {
			position  : toast.POSITION.TOP_RIGHT,
			className : 'toast-message'
		});
	};

	fileRejections?.forEach((rejection) =>
	{
		const { errors } = rejection;

		if (errors.some((e) => e.code === 'file-too-large'))
		{
			errorMessages.add(language?.cantnot20Mb);
		}
		else if (errors.some((e) => e.code === 'file-invalid-type'))
		{
			errorMessages.add(language.fileNotSupported);
		}
		else if (errors.some((e) => e.code === 'too-many-files'))
		{
			errorMessages.add(`${language.cannotUploadMoreThan} ${maxFiles} ${language.files}.`);
		}
		else
		{
			errorMessages.add(language.fileTypeMustBe);
		}
	});
	errorMessages.forEach((message) => showToastError(message));
};

const uploadFiles = async (file, path) =>
{
	try
	{
		const upload = await newNewsFeedUploadFiles([ file ], path);

		if (upload && upload[0])
		{
			return {
				url       : upload[0]?.url,
				type      : upload[0]?.type,
				key       : upload[0]?.key,
				videotext : upload[0]?.key,
				title     : upload[0]?.key,
				name      : upload[0]?.name,
				size      : upload[0]?.size
			};
		}
		else
		{
			console.log('Upload failed____________');
		}
	}
	catch (err)
	{
		console.log(err, '----------err');
	}
};

export const uploadProgressImg = async (file, setLoading, path, initialState = {}) =>
{
	if (file?.type?.startsWith('image/'))
	{
		const from = Object?.keys(initialState)?.length > 0;

		return new Promise(async (resolve, reject) =>
		{
			if (file.type === 'image/gif')
			{
				const uploadedD = await uploadFiles(file, path);

				const newImgObj = {
					...uploadedD,
					tab : from ? 2 : 1,
					...(from ? { dataUrl: await getBlobUrl(uploadedD?.key) } : {}),
					...(from ? { styles: initialState } : {})
				};

				resolve(newImgObj);
				setLoading(false);

				return;
			}

			let fileToCompress:any = file;

			if (file?.type === 'image/heic' || file?.type === 'image/webp' || file?.type === 'application/octet-stream' || file?.name?.toLowerCase()?.endsWith('.heic') || file?.name?.toLowerCase()?.endsWith('.webp'))
			{
				try
				{
					let convertedBlob;

					if (file?.type === 'image/webp' || file?.name?.toLowerCase()?.endsWith('.webp'))
					{
						const fileName = file.name.replace(/\.[^/.]+$/, '.jpg');

						convertedBlob = new File([ file ], fileName, { type: 'image/jpeg' });
					}
					else
					{
						convertedBlob = await heic2any({
							blob   : file,
							toType : 'image/jpeg' });
					}

					const blob:any = convertedBlob instanceof Blob ? convertedBlob : convertedBlob.slice();// creating a new Blob

					const fileName = file.name.replace(/\.[^/.]+$/, '.jpg');

					fileToCompress = new File([ blob ], fileName, { type: 'image/jpeg' });
				}
				catch (err)
				{
					console.log(err);
				}
			}

			new Compressor(fileToCompress, {
				quality : 0.4,
				success : async (result) =>
				{
					try
					{
						const upload = await newNewsFeedUploadFiles([ result ], path);

						if (upload)
						{
							const uploadData = await uploadFiles(result, path);
							const newImgObj = {
								...uploadData,
								tab : from ? 2 : 1,
								...(from ? { dataUrl: await getBlobUrl(uploadData?.key) } : {}),
								...(from ? { styles: initialState } : {})
							};

							resolve(newImgObj);
							setLoading(false);
						}
						else
						{
							reject(new Error('Upload failed'));
							setLoading(false);
						}
					}
					catch (err)
					{
						console.log(err);
						setLoading(false);
					}
				},
				error : (err) =>
				{
					reject(err);
					setLoading(false);
				}

			});
		});
	}
};
export const acceptedImages = {
	'image/png'  : [ '.png' ],
	'image/gif'  : [ '.gif' ],
	'image/jpeg' : [ '.jpeg', '.jpg' ],
	'image/webp' : [ '.webp' ],
	'image/heif' : [ '.heic' ]
};

export const acceptedVideos = {
	'video/mp4'       : [ '.mp4' ],
	'video/x-msvideo' : [ '.avi' ], // For .avi files
	'video/x-flv'     : [ '.flv' ], // For .flv files
	'video/webm'      : [ '.webm' ]
};

export const acceptedDocs = {
	'application/msword'                                                        : [ '.doc' ], // For .doc files
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document'   : [ '.docx' ], // For .docx files
	'application/pdf'                                                           : [ '.pdf' ], // For .pdf files
	'application/vnd.ms-excel'                                                  : [ '.xls' ], // For .xls files
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'         : [ '.xlsx' ], // For .xlsx files
	'application/vnd.ms-powerpoint'                                             : [ '.ppt' ], // For .ppt files
	'application/vnd.openxmlformats-officedocument.presentationml.presentation' : [ '.pptx' ] // For .pptx files
};